import { useCallback, type FC } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import {
  AutoplayModifyButton,
  AutoplayModifyButtonProps,
} from '@pp/core/src/components/game/autoplayV2/buttons/modifyButton/AutoplayModifyButton';
import { Logger } from '@pp/core/src/logger/Logger';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';

import { Bets } from '../../../../config/bets';
import { useCrashAutoplaySlice } from '../../../../store/slices/crashAutoplay/selectors';
import { crashAutoplayActions } from '../../../../store/slices/crashAutoplay/slice';
import { useValidBetInputValue } from '../../../gameGrid/hooks/useValidBetInputValue';

export interface AutoplayModifyButtonConnectedProps extends Pick<AutoplayModifyButtonProps, 'addOn' | 'disabled'> {
  betId: Bets;
}

export const CrashAutoplayModifyButtonConnected: FC<AutoplayModifyButtonConnectedProps> = ({
  betId,
  addOn,
  disabled,
}) => {
  const dispatch = useCoreDispatch();
  const { betInputAmount } = useValidBetInputValue(betId);

  const maxRoundsLimit = useCrashAutoplaySlice.getAutoplayMaxRoundsLimit(betId);
  const roundsLeft = useCrashAutoplaySlice.getRemainingCount(betId);
  const isRoundsLimitReached = maxRoundsLimit === roundsLeft;

  const addRounds = useCallback((): void => {
    dispatch(crashAutoplayActions.addRounds({ betsSpot: betId, value: addOn }));
    Logger.logEvent('autoplay_modify', {
      additional: addOn.toString(),
    });
  }, [dispatch]);

  return (
    <AutoplayModifyButton
      addOn={addOn}
      totalBet={<CurrencyConnected value={betInputAmount * addOn} />}
      onClick={addRounds}
      disabled={isRoundsLimitReached || disabled}
    />
  );
};
